import axios from "@/api/axiosInstance";
import {
  SubscribeRecurringEmailRecipientsRequest,
  SubscribeRecurringEmailRecipientsResponse,
} from "./types";

export const subscribeRecurringEmailRecipients = async (
  recurringEmail: string,
  requestData: SubscribeRecurringEmailRecipientsRequest,
): Promise<SubscribeRecurringEmailRecipientsResponse> => {
  const response = await axios.post<SubscribeRecurringEmailRecipientsResponse>(
    `/api/private/recurring-emails/${recurringEmail}/recipients`,
    requestData,
  );
  return response.data;
};
